var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.layoutType === 'horizontal')?_c('Horizontal',{attrs:{"layout":this.layoutType}},[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }